import _ from 'underscore';

export default class UserProductEndUses {
  constructor($scope, $rootScope, UserProductEndUseService) {
    function load_product_end_uses() {
      $scope.loading = true;
      UserProductEndUseService.get(window.user_id).success(function(data) {
        _.each(data.product_end_uses, function(end_use) {
          var product_end_use = _.findWhere($scope.product_end_uses, {
            id: end_use
          });
          if (product_end_use) {
            product_end_use.checked = true;
          }
        });

        _.each(data.suggested_product_end_uses, function(end_use) {
          var product_end_use = _.findWhere($scope.product_end_uses, {
            id: end_use
          });
          if (product_end_use) {
            product_end_use.suggested = true;
          }
        });
        $scope.loading = false;
      });
    }

    $scope.update = function() {
      $scope.updating = true;
      var product_end_uses = _.where($scope.product_end_uses, {
        checked: true
      });
      product_end_uses = _.pluck(product_end_uses, 'id');
      UserProductEndUseService.update(window.user_id, product_end_uses).success(function() {
        $scope.updating = false;
        $rootScope.$broadcast('set_sidebar_data', [0, 1, [{
          type: 'counter',
          value: product_end_uses.length
        }]]);
      });
    };

    $scope.quick_search = function() {
      if ($scope.quick_filter) {
        var regex = new RegExp($scope.quick_filter, 'i');
        _.each($scope.product_end_uses, function(end_use) {
          end_use.visible = end_use.title.search(regex) > -1;
        });

        $scope.search_filter = {
          visible: true
        };
      } else {
        $scope.search_filter = {};
      }
    };

    $scope.init = function() {
      $scope.show_all = false;
      load_product_end_uses();
      $scope.product_end_uses = window.product_end_uses;
    };

    $scope.init();

  }
}

UserProductEndUses.$inject = ['$scope', '$rootScope', 'UserProductEndUseService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-end-uses.ctrl.js